﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get values() {
        return {
            settings: Object
        };
    }

    static get targets() {
        return ["helpCenterButton"];
    }

    async initialiseIntercom() {
        return new Promise(resolve => {
            window.intercomSettings = this.settingsValue;
            const script = document.createElement("script");
            script.src = `https://widget.intercom.io/widget/${this.settingsValue.app_id}`;
            script.addEventListener("load", () => {
                resolve();
            });
            document.body.appendChild(script);
        });
    }

    async launchIntercom() {
        this.helpCenterButtonTarget.classList.add("d-none");
        const promises = [];

        if (!window.Intercom) {
            promises.push(this.initialiseIntercom());
        }

        await Promise.allSettled(promises);
        window.Intercom("show");
        window.Intercom("onHide", () => {
            this.helpCenterButtonTarget.classList.remove("d-none");
            this.helpCenterButtonTarget.focus();
        });
    }

    async connect() {
        await new Promise(resolve => setTimeout(resolve, 20000));
        this.helpCenterButtonTarget.addEventListener("click", e => this.launchHelp(e));
        this.helpCenterButtonTarget.style.transform = "";
    }

    launchHelp(e) {
        this.launchIntercom();
        e.preventDefault();
    }
}